// stripe.button.component.jsx
import axios from 'axios';
import React from 'react';
import StripeCheckout from 'react-stripe-checkout';
import { toast } from 'react-toastify';
import firebase from 'firebase/compat/app';


const StripeCheckoutButton = ({ price }) => {
  
    const priceForStripe = price * 100;
    const publishableKey = 'pk_live_51K9EQHR2JbzBouTUuFMPqi9G2E4TOwSjgHGFYQG0ZDmOqDMhbdcQEhedOxxEKKO0sgkgN2Jf3Ge65FbeIesqsBjA00QxM2KkPm';
    
    // storing data in firebase

    const db = firebase.firestore();
    const user = firebase.auth().currentUser;
    const userId = user.uid;
    const userEmail = user.email;
    db.collection('checkout').add({
        userId: userId,
        userEmail: userEmail,
        price: price,
        date: new Date(),
        wallet: localStorage.getItem('LAST_ACTIVE_ACCOUNT'),
        nftid : localStorage.getItem('fileid'),
        paymentmethod : 'card / coinbase'
    })
    .then(function(docRef) {
        console.log("Document written with ID: ", docRef.id);
    })
    .catch(function(error) {
        console.error("Error adding document: ", error);
    });




        
    const onToken = (token) => {
        axios.post('https://us-central1-diginoor-3755e.cloudfunctions.net/app/create-payment-intent',
            {
              description: `Your total is $${price}`,
              source: token.id,
              currency: 'usd',
              amount: priceForStripe
            })
            .then((response) => {
              // console.log('Response from stripe payment', response)
              const file_id = localStorage.getItem('fileid') //getting the particular value from the local storage
              window.location.href ="../../../Nft_conformation/"+ file_id;            })
            .catch((error) => {
              // console.log('Payment error here', error.response.data)
              const errorResp = error.response.data;
              try {
              alert(`${errorResp.error.type}, ${errorResp.error.raw.message}`);
              } catch (e) {
                alert('Payment failed');
              }
            });
    };
    if(localStorage.getItem('LAST_ACTIVE_ACCOUNT') === null) {
      alert('Please connect wallet to continue');
      window.location.href ="../../../Wallet/";
      
  }
  else {
    return (
        <StripeCheckout
            label='Pay Now'
            name='Diginoor Inc.'
            billingAddress
            shippingAddress
            image='https://i.ibb.co/sP2M8tP/download.png'
            description={`Your total is $${price}`}
            amount={priceForStripe}
            panelLabel='Pay Now'
            token={onToken}
            stripeKey={publishableKey}>
            <button className="place-a-bid-btn0">Pay with Card</button>
            </StripeCheckout>
    )
  }
  
    

}

export default StripeCheckoutButton;